export default __webpack_public_path__ + "static/media/NZL.526fbaf1.svg";